import _mergeJSXProps, { default as _mergeJSXProps2 } from "@vue/babel-helper-vue-jsx-merge-props";
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var JsonView_1;
import { Component, Prop, Vue } from 'vue-property-decorator';
import { toPathParts } from '@tencent/data-schema-core/lib/utils/path';
import { highlightRect } from "../../../../lib/utils/browser";
const checkDataType = curLevel => {
  if (typeof curLevel === 'object') {
    if (Array.isArray(curLevel)) {
      return 'array';
    }
    if (!curLevel) return 'NULL';
    return 'object';
  }
  return typeof curLevel;
};
const deepFilterObject = (obj, filterStr, curDataType = 'object') => {
  let deleteAll = true;
  if (curDataType === 'object') {
    Object.entries(obj).forEach(([key, value]) => {
      const type = checkDataType(value);
      if (type === 'object') {
        const res = deepFilterObject(value, filterStr, type);
        if (res) delete obj[key];else deleteAll = false;
      } else if (type === 'array') {
        const res = deepFilterObject(value, filterStr, type);
        if (res) delete obj[key];else deleteAll = false;
      } else if (!`${key}`.includes(filterStr) && !`${value}`.includes(filterStr)) {
        delete obj[key];
      } else {
        deleteAll = false;
      }
    });
  } else if (curDataType === 'array') {
    const res = obj.filter(item => {
      const type = checkDataType(item);
      if (type === 'object') {
        const res = deepFilterObject(item, filterStr, type);
        if (res) return false;
        deleteAll = false;
      } else if (type === 'array') {
        const res = deepFilterObject(item, filterStr, type);
        if (res) return false;
        deleteAll = false;
      } else return `${item}`.includes(filterStr);
      return true;
    });
    obj = [];
    res.forEach((item, index) => {
      obj.splice(index, 1, item);
    });
  }
  return deleteAll;
};
// 这是一个纯组件，不需要mixins
let JsonView = JsonView_1 = class JsonView extends Vue {
  constructor() {
    super(...arguments);
    this.expanded = false;
  }
  get rootView() {
    var _this$doNotUseGetRoot;
    return ((_this$doNotUseGetRoot = this.doNotUseGetRootView) === null || _this$doNotUseGetRoot === void 0 ? void 0 : _this$doNotUseGetRoot.call(this)) || this;
  }
  get propsForChildren() {
    return {
      attrs: {
        rootLevelKeys: this.rootLevelKeys,
        doNotUseGetRootView: this.doNotUseGetRootView || (() => this),
        currentDepth: this.currentDepth + 1
      },
      scopedSlots: this.$scopedSlots,
      class: 'ucd-domTree-subTree'
    };
  }
  created() {
    this.$watch(() => this.rootLevelKeys.includes(this.initKey) || this.rootView.defaultExpandDepth > this.currentDepth, shallExpand => {
      this.expanded = shallExpand;
    }, {
      immediate: true
    });
  }
  /** Computed */
  get localData() {
    return this.value;
  }
  /** 展开并跳转到指定层级 */
  async goto(path) {
    if (!path || !path.length) {
      var _this$$el$scrollIntoV, _this$$el;
      (_this$$el$scrollIntoV = (_this$$el = this.$el).scrollIntoViewIfNeeded) === null || _this$$el$scrollIntoV === void 0 || _this$$el$scrollIntoV.call(_this$$el);
      await Vue.nextTick();
      highlightRect(this.$el.getBoundingClientRect());
      return;
    }
    if (!this.expanded) {
      this.expanded = true;
      await Vue.nextTick();
    }
    const refs = this.$refs.childrenInstances || [];
    const parts = toPathParts(path);
    const sub = refs.find(x => String(x.initKey) === parts[0]);
    if (!sub) return;
    await sub.goto(parts.slice(1));
  }
  toggleExpand() {
    const eventPayload = this.getEventPayload();
    this.rootView.$emit(this.expanded ? 'expand' : 'collapse', eventPayload);
    this.expanded = !this.expanded;
  }
  handleMouseDown(e) {
    if (e.currentTarget.classList.contains('ucd-domTree-row')) {
      if (e.target.classList.length) {
        e.preventDefault();
      }
    }
  }
  getEventPayload() {
    let {
      path
    } = this;
    if (path.startsWith('.')) path = path.slice(1);
    return {
      key: this.initKey,
      path,
      value: this.value
    };
  }
  handleClick() {
    const eventPayload = this.getEventPayload();
    this.rootView.$emit('click', eventPayload);
  }
  get openTag() {
    const h = this.$createElement;
    const {
      path,
      tag
    } = this;
    return h("div", {
      "class": "ucd-domTree-row",
      "on": {
        "click": this.handleClick,
        "dblclick": this.toggleExpand,
        "mousedown": this.handleMouseDown
      }
    }, [h("a-icon", {
      "attrs": {
        "type": this.expanded ? 'caret-down' : 'caret-right'
      },
      "class": "ucd-domTree-row-arrow",
      "on": {
        "click": () => this.toggleExpand()
      }
    }), h("span", {
      "class": `ucd-domTree-row-container ${this.$scopedSlots.default ? 'hide-last-span' : ''}`
    }, [h("span", {
      "class": "ucd-domTree-nodeName-tagName"
    }, [tag, " "]), this.$scopedSlots.default ? this.$scopedSlots.default({
      path,
      value: this.value
    }) : null])]);
  }
  get tag() {
    const tag = `${!!this.initKey ? `${this.initKey}: ` : `${this.type}: `}`;
    switch (this.type) {
      case 'array':
        return `${tag} [${(this.localData || []).length}]`;
      case 'object':
        return `${tag} {${Object.keys(this.localData || {}).length}}`;
      default:
        return tag;
    }
  }
  get type() {
    return checkDataType(this.localData);
  }
  get recursiveBuildTree() {
    const h = this.$createElement;
    let children;
    const tempData = JSON.parse(JSON.stringify(this.localData));
    if (this.filterStr) deepFilterObject(tempData, this.filterStr, this.type);
    switch (this.type) {
      case 'array':
        children = this.expanded ? (tempData || []).map((data, index) => h(JsonView_1, _mergeJSXProps([{
          "attrs": {
            "value": data,
            "path": `${this.path}[${index}]`,
            "initKey": `${index}`,
            "siblingHasContainer": (tempData || []).some(child => checkDataType(child) === 'object' || checkDataType(child) === 'array')
          },
          "ref": "childrenInstances",
          "refInFor": true
        }, this.propsForChildren]))) : null;
        return [this.openTag, children];
      case 'object':
        children = this.expanded ? Object.entries(tempData || {}).map(([k, v]) => h(JsonView_1, _mergeJSXProps2([{
          "attrs": {
            "value": v,
            "path": `${this.path}.${k}`,
            "initKey": k,
            "siblingHasContainer": Object.values(tempData || {}).some(child => checkDataType(child) === 'object' || checkDataType(child) === 'array')
          },
          "ref": "childrenInstances",
          "refInFor": true
        }, this.propsForChildren]))) : null;
        return [this.openTag, children];
      // case 'number':
      // case 'boolean':
      // case 'string':
      // case 'NULL':
      // case 'undefined':
      default:
        children = h("span", {
          "class": `leaf ${this.type}`
        }, [this.type === 'string' && h("span", {
          "style": {
            color: '#7f7f7f'
          }
        }, ["\""]), `${this.type === 'function' ? 'function ()' : this.localData}`, this.type === 'string' && h("span", {
          "style": {
            color: '#7f7f7f'
          }
        }, ["\""])]);
        // 以后要加选择的能力，补充
        // class={`ucd-domTree-row-leaf ${this.selectable ? 'selectable' : ''} ${this.selected ? 'selected' : ''}`}
        return h("div", {
          "class": 'ucd-domTree-row-leaf',
          "on": {
            "click": this.handleClick
          }
        }, [h("span", {
          "style": {
            color: 'green'
          }
        }, [" ", this.initKey, ": "]), " ", children]);
    }
  }
  get children() {
    return this.recursiveBuildTree;
  }
  render() {
    const h = arguments[0];
    const {
      children
    } = this;
    return h("div", {
      "class": "uc-jsonView"
    }, [h("div", {
      "class": "ucd-domTree"
    }, [children])]);
  }
};
__decorate([Prop({
  required: true
})], JsonView.prototype, "value", void 0);
__decorate([Prop({
  type: String,
  default: ''
})], JsonView.prototype, "initKey", void 0);
__decorate([Prop({
  type: String,
  default: ''
})], JsonView.prototype, "path", void 0);
__decorate([Prop({
  type: Array,
  default: () => []
})], JsonView.prototype, "rootLevelKeys", void 0);
__decorate([Prop({
  type: Number,
  default: 2
})], JsonView.prototype, "defaultExpandDepth", void 0);
__decorate([Prop({
  type: String,
  default: ''
})], JsonView.prototype, "filterStr", void 0);
__decorate([Prop({
  type: Number,
  default: 0
})], JsonView.prototype, "currentDepth", void 0);
__decorate([Prop({
  default: null
})], JsonView.prototype, "doNotUseGetRootView", void 0);
__decorate([Prop({
  type: Boolean,
  default: false
})], JsonView.prototype, "siblingHasContainer", void 0);
JsonView = JsonView_1 = __decorate([Component({
  name: 'WJsonview'
})], JsonView);
export default JsonView;
//# sourceMappingURL=index.js.map
